import type { ParseKeys } from "i18next";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { CommandGroup } from "@/components/ui/command";

import { GLOBAL_SEARCH_GROUP_TITLE_KEYS } from "./constants";
import { GlobalSearchItemRow } from "./GlobalSearchItemRow";
import type { IGlobalSearchGroupProps } from "./types";

// NOTE: A section of results under its heading. Kept in the same visual
// language as the chat sections: small secondary heading, rows below.
const GlobalSearchGroupComponent = ({
  group,
  onSelectItem,
}: IGlobalSearchGroupProps): JSX.Element => {
  const { t } = useTranslation("globalSearch");
  const titleKey: ParseKeys<"globalSearch"> | undefined =
    GLOBAL_SEARCH_GROUP_TITLE_KEYS[group.type];

  return (
    <div
      className="mt-3 first:mt-0"
      data-testid={`global-search-group-${group.type}`}
    >
      <h3 className="truncate px-3 pb-1.5 pt-2 text-xs font-medium text-foreground-secondary">
        {titleKey ? t(titleKey) : group.type}
      </h3>
      <CommandGroup className="p-0">
        {group.items.map((item) => (
          <GlobalSearchItemRow
            key={`${item.type}:${item.id}`}
            item={item}
            onSelectItem={onSelectItem}
          />
        ))}
      </CommandGroup>
    </div>
  );
};

export const GlobalSearchGroup = memo(GlobalSearchGroupComponent);
